import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DocumentCsv16Icon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path d="M4.7 8.7c0-.4.3-.7.6-.7h1.4a.7.7 0 1 1 0 1.3H5.3a.7.7 0 0 1-.6-.6Zm.6 2a.7.7 0 0 0 0 1.3h1.4a.7.7 0 1 0 0-1.3H5.3Zm3.4-2c0-.4.3-.7.6-.7h1.4a.7.7 0 1 1 0 1.3H9.3a.7.7 0 0 1-.6-.6Zm.6 2a.7.7 0 0 0 0 1.3h1.4a.7.7 0 1 0 0-1.3H9.3Z" />
      <path
        fillRule="evenodd"
        d="M4 .7a2 2 0 0 0-2 2v10.6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a.7.7 0 0 0-.2-.5L10.1 1a.7.7 0 0 0-.4-.2H4ZM8.7 2H4a.7.7 0 0 0-.7.7v10.6a.7.7 0 0 0 .7.7h8a.7.7 0 0 0 .7-.7V6H9.3a.7.7 0 0 1-.6-.7V2ZM12 4.7h-2v-2l2 2Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default DocumentCsv16Icon;
